export default "__VITE_ASSET__1d4ee133__"